import { createDialog } from '@/infrastructure/decorators/dialog';
export function createTemplateEditDialog() {
    return createDialog(() => import('../../presentation/components/TemplateLibrary/ReportTemplateEditDialog.vue'));
}
